import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import DialogList from 'src/dialogs';

interface ICreateCheckWarningDialogProps {
    dialogName: string;
    handleConfirm?: () => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
}

const CreateCheckWarningDialog = (props: ICreateCheckWarningDialogProps) => {

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('CreateCheckWarningDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleConfirm();
        props.hideDialog();
        props.showDialog(DialogList.OUTPUT_DESTINATION);
    };

    return (
        <Dialog title="Warning" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <label>Are you sure you want to create a check for this invoice?</label>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default CreateCheckWarningDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/CreateCheckWarningDialog.tsx